/**
 * @file
 * One upload progress row.
 */

((Drupal) => {
  const { berTags } = Drupal;
  const { components } = berTags;
  const { el, textSpan } = berTags.dom;

  // One upload progress row: name plus a 0-1 progress bar.
  components.progressRow = (list, name) => {
    const li = el('li');
    const label = textSpan('ber-upload__progress-name', name);
    const progress = el('progress');
    progress.max = 1;
    progress.value = 0;
    li.append(label, progress);
    list.appendChild(li);
    return { li, label, progress };
  };
})(Drupal);
